module.exports = __webpack_public_path__ + "img/bdg_hold.ef4441ed.svg";